import React, { Fragment } from 'react'
import estilos from './PrediosComponenet.module.css'
import prediosSinFondo from '../../../../../img/prediosSinFondo.png'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

function PrediosComponent(props) {

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.predioclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.predioclientehistorial)
        setOpenModalHistorial(true)
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });
    
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                    <div className={`${estilos.section} text-center py-5 py-md-0`}>
                        <div className={`${estilos.card3dWrap} mx-auto`} >
                            <div className={`${estilos.card3dWrapper} mx-auto`} >
                                <div className={`${estilos.cardBack}`}>
                                    <div className={props?.data.isbaja ? `${estilos.pricingWrapBaja}` : `${estilos.pricingWrap}`}>
                                        <h4 className={`${estilos.h4} mb-5`}></h4>
                                        <div className='row' style={{ marginTop: '60%', fontFamily: 'Montserrat' }}>
                                            {props?.data?.isbaja == false &&
                                                <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                    <Tooltip title="Ver historial de cambios">
                                                        <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                            <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            }
                                            {props?.data?.isbaja == true &&
                                                <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                    <IconButton size="large" sx={{ p: 1 }} disableFocusRipple disableRipple disabled >
                                                        <HistoryRoundedIcon fontSize="inherit" sx={{ color: 'white' }} />
                                                    </IconButton>
                                                </div>
                                            }
                                            < p className="mt-3 mb-4 ps-5 pe-5"><b>Predio:</b> {props?.data?.nombreparaje?.toUpperCase()}</p>
                                            <p className="mb-4 ps-5 pe-5"><b>Tipo Plantación:</b> {props?.data?.cultivado ? 'CULTIVADO' :
                                                props?.data?.semicultivado ? 'SEMICULTIVADO' :
                                                    props?.data?.silvestre ? 'SILVESTRE' :
                                                        ''}</p>
                                            <p className="mb-4 ps-5 pe-5"><b>Domicilio:</b> {props?.data?.localidad?.toUpperCase() + ', ' + props?.data?.municipio?.toUpperCase() + ', ' +
                                                props?.data?.distrito?.toUpperCase() + ', ' + props?.data?.estado?.toUpperCase()}</p>
                                            
                                        </div>
                                        <div className={`${estilos.imgWrap} ${estilos.img} ${estilos.img2}`}>
                                            <img src={prediosSinFondo} alt="" style={{ width: '100%' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Predios"} />}

            </ThemeProvider>
        </Fragment >
    )
}

export default PrediosComponent